import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  "Logo": {content: <Skeleton height="70px" width="70px" />, center: true},
  "Name": {content: <Skeleton height="20px" width="120px" />, center: true},
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const AmenitiesSkeleton = () => {
  return (
    <DynamicSkeleton
      rows={4}
      columnConfig={columnConfig}
    />
  )
}

export default AmenitiesSkeleton
